/**
 * DB(UTC) 타임스탬프 문자열 → Date 객체 (로컬/KST 기준)
 * timezone 정보가 없는 문자열에 "Z"를 붙여 UTC로 인식시킴.
 * 이후 Date 메서드(getHours 등)는 브라우저 로컬(KST) 기준으로 동작.
 */
export function parseUTC(value) {
  if (!value) return null;
  const s = String(value).trim();
  const hasTimezone =
    s.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(s) || /[+-]\d{4}$/.test(s);
  const d = new Date(hasTimezone ? s : s + "Z");
  return Number.isNaN(d.getTime()) ? null : d;
}

// 공통 포맷터들
const toISODateLocal = (d) => {
  // YYYY-MM-DD (로컬 기준, TZ 드리프트 방지)
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const toMDKey = (d) => {
  // MM/DD (항상 두 자리 + 슬래시)
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${m}/${day}`;
};

// 날짜 범위 생성: fullDate=YYYY-MM-DD, date=MM/DD (슬래시)
export const generateDateRange = (startDate, endDate) => {
  const dates = [];
  const current = new Date(startDate);
  const end = new Date(endDate);

  // 로컬 자정 정규화(선택)
  current.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  while (current <= end) {
    dates.push({
      fullDate: toISODateLocal(current), // "YYYY-MM-DD"
      date: toMDKey(current), // "MM/DD" ← ★ 통일
    });
    current.setDate(current.getDate() + 1);
  }
  return dates;
};

// M/D → MM/DD 로 통일
export const fmtMD = (d) => toMDKey(d);

// allDates를 MM/DD로 생성
export const buildAllDatesMD = (startDate, endDate) => {
  if (!startDate || !endDate) return [];
  const s = new Date(startDate);
  const e = new Date(endDate);
  s.setHours(0, 0, 0, 0);
  e.setHours(0, 0, 0, 0);
  const arr = [];
  for (let d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    arr.push(toMDKey(d)); // MM/DD (두 자리 + 슬래시)
  }
  return arr;
};

// allDates(MM/DD)와 data.date(MM/DD) 매칭
export const ensureAllDates = (data, allDates, keys = []) => {
  if (!Array.isArray(allDates) || allDates.length === 0) return data;

  const map = new Map((data || []).map((d) => [d.date, d]));
  return allDates.map((date) => {
    const base = { date, ...(map.get(date) || {}) };
    for (const k of keys) {
      if (!(k in base)) base[k] = null;
    }
    return base;
  });
};

export function formattedTime(capturedAt) {
  const d = parseUTC(capturedAt);
  if (!d) return String(capturedAt ?? "");
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${y}-${mo}-${day} ${hh}:${mm}`;
}
